import SHSkeleton, {
  SHSkeletonProps,
} from "@components/design-systems/sh-skeleton";

export const SHUploadFileSkeleton = ({ ...others }: SHSkeletonProps) => {
  return <SHSkeleton height={120} width={520} {...others} />;
};
